"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationContext = exports.useTranslation = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("core/types");
const react_1 = require("react");
const eng_json_1 = tslib_1.__importDefault(require("core/helpers/eng.json"));
const geo_json_1 = tslib_1.__importDefault(require("core/helpers/geo.json"));
function useTranslation() {
    return (0, react_1.useContext)(exports.TranslationContext);
}
exports.useTranslation = useTranslation;
const initialTranslation = {
    selectedLanguage: types_1.LanguageType.GEO,
    changeLanguage: () => ({}),
    translate: () => ''
};
exports.TranslationContext = (0, react_1.createContext)(initialTranslation);
const TranslationProvider = ({ children }) => {
    const [selectedLanguage, setSelectedLanguage] = (0, react_1.useState)(types_1.LanguageType.GEO);
    const getLocalstorage = async () => {
        const lang = localStorage.getItem('language');
        setSelectedLanguage(Number(lang) || types_1.LanguageType.GEO);
    };
    const changeLanguage = (lang) => {
        setSelectedLanguage(lang);
        localStorage.setItem('language', String(lang));
    };
    const translate = (key, defaultValue) => {
        if (selectedLanguage === types_1.LanguageType.GEO)
            return geo_json_1.default[key] || defaultValue;
        if (selectedLanguage === types_1.LanguageType.ENG)
            return eng_json_1.default[key] || defaultValue;
        return defaultValue;
    };
    (0, react_1.useEffect)(() => {
        getLocalstorage().then();
    }, []);
    const value = {
        changeLanguage,
        selectedLanguage,
        translate
    };
    return (0, jsx_runtime_1.jsx)(exports.TranslationContext.Provider, { value: value, children: children });
};
exports.default = TranslationProvider;
